/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { CloseCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { Col, Row, message } from 'antd';
import { useMutation } from '@apollo/react-hooks';
import UPDATE_PAYMENT_VOUCHER_MUTATION, {
  UpdatePaymentVoucherData,
  UpdatePaymentVoucherVars,
} from 'shared/graphql/mutation/updatePaymentVoucher';
import formatCurrency from 'shared/utils/formatCurrency';
import { Button, Text } from 'shared/components';
import { StyledModal } from './Styles';

type ModalConfirmDeletePaymentProps = {
  paymentVoucherId: string;
  paymentsId: string[];
  payment: {
    id: string;
    createDate: string;
    paymentNumber: string;
    totalPrice: number;
  };
  visible: boolean;
  onCancel: () => void;
};

const ModalConfirmDeletePayment: React.FC<ModalConfirmDeletePaymentProps> = (props) => {
  const { onCancel, visible, paymentsId, payment, paymentVoucherId } = props;
  const [updatePaymentVoucher, { loading }] = useMutation<
    UpdatePaymentVoucherData,
    UpdatePaymentVoucherVars
  >(UPDATE_PAYMENT_VOUCHER_MUTATION, {
    update: (_cache, { data }) => {
      if (data?.updatePaymentVoucher._id) {
        message.success('ลบรายการแล้ว');
        onCancel();
      }
    },
    onError: (err) => {
      message.error(err.message);
    },
    refetchQueries: () => [
      'PaymentVoucher',
      'PaymentVoucherStatus',
      'PaymentVouchers',
      'PaymentStatus',
    ],
  });

  const confirmUpdate = () => {
    updatePaymentVoucher({
      variables: {
        _id: paymentVoucherId,
        payment: paymentsId.map((item) => item),
      },
    });
  };

  return (
    <StyledModal
      className="custom-modal"
      title="ยืนยันการลบใบแจ้งหนี้หรือไม่?"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button
          key="okButton"
          icon={<DeleteOutlined />}
          color="red"
          onClick={() => confirmUpdate()}
          loading={loading}
        >
          ลบใบแจ้งหนี้
        </Button>,
        <Button
          key="cancelButton"
          icon={<CloseCircleOutlined />}
          onClick={onCancel}
          disabled={loading}
        >
          ยกเลิก
        </Button>,
      ]}
    >
      <Row>
        <Col span={6}>รหัสใบแจ้งหนี้:</Col>
        <Col span={18}>
          <Text strong>{payment.paymentNumber}</Text>
        </Col>
      </Row>
      <Row>
        <Col span={6}>มูลค่าใบแจ้งหนี้:</Col>
        <Col span={18}>
          <Text strong customType="primary">
            {formatCurrency(payment.totalPrice)}
          </Text>
        </Col>
      </Row>
    </StyledModal>
  );
};

export default ModalConfirmDeletePayment;
